import {DEFAULT_SEARCH_PARAMS as BASE_SEARCH_PARAMS} from '@salesforce/retail-react-app/app/constants';

export * from '@salesforce/retail-react-app/app/constants';

export const DEFAULT_SITE_TITLE = 'King Living';

export const DEFAULT_LIMIT_VALUES = [25, 50, 100];
export const DEFAULT_SEARCH_PARAMS = {...BASE_SEARCH_PARAMS, limit: 3};

// Formcrafts "Notify Me" form URL
export const NOTIFY_ME_BASE_URL = 'https://app.formcrafts.com/10f59c4a';

// Range Detail PLP — products fetched per lazy-load batch (KINDW-99 / FSD PLP-03).
export const RANGE_PLP_PAGE_SIZE = 16;

/** DOM id for PLP heading — Contentful hash links (e.g. `#range-detail-heading`) anchor here. */
export const RANGE_DETAIL_PLP_HEADING_ID = 'range-detail-heading';

// Range Detail PLP — IntersectionObserver rootMargin for the load-more sentinel (px).
// Triggers next-page fetch ~one viewport before the user actually reaches the end.
export const RANGE_PLP_LAZY_LOAD_ROOT_MARGIN_PX = 400;

// Range Detail PLP — eager-load throttle for the lazy grid.
//
// Cap how many tiles set their first image to `loading="eager"` on initial paint. Tiles outside
// this window stay `loading="lazy"` and load only as the user scrolls — spreading the cold-render
// request burst over time instead of hitting Cylindo with N parallel requests synchronously.
// 4 ≈ the typical above-fold tile count on desktop (4-column grid, partial 2nd row hidden).
export const RANGE_PLP_EAGER_TILE_COUNT = 4;

// Category Landing Page (CMS `pageType=category`) — visual per-module reveal of region modules.
//
// All Contentful data is fetched up-front in the single page-level GraphQL query — this is not
// a real lazy load. The first `CATEGORY_LANDING_INITIAL_MODULE_COUNT` modules render normally
// on first paint; every module past that is wrapped in a `<RevealOnScroll>` that keeps it at
// `opacity: 0; translateY(40px)` until ITS OWN IntersectionObserver reports the module has
// entered the viewport, at which point a CSS transition fades it in. The observer is only
// attached after `window.load` so layout instability during image loading can't fire it early
// (see `docs/plp/category-landing-lazy-reveal.md`).
export const CATEGORY_LANDING_INITIAL_MODULE_COUNT = 2;

// Fade-in duration (ms) for region modules past the initial chunk. Long enough that the reveal
// reads as a deliberate lazy load rather than an instant render — 1.2 s feels organic without
// being sluggish. Adjust here if the FSD wants a different cadence.
export const CATEGORY_LANDING_FADE_DURATION_MS = 2400;

// IntersectionObserver `threshold` for the per-module fade-in trigger. `0.1` means the fade
// animation starts the instant ~10 % of the module's height has scrolled into the viewport —
// so the shopper sees the transition happen as the module comes into view.
export const CATEGORY_LANDING_REVEAL_THRESHOLD = 0.1;
